import * as React from 'react';
import { Layout, Space, Typography } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';
import modules_885eb418 from './styles/PreFooter.module.less.js';

const { Link, ListItem, Text, UnorderedList } = Typography;
/**
 * @description PreFooter component.
 *
 * @component
 * @example
 * ```jsx
 * <PreFooter columns={...}/>
 * ```
 */
const PreFooter = React.forwardRef((props, ref) => {
    const { title = 'Часто ищут', columns, className, ...restProps } = props;
    const cx = useStyles(modules_885eb418);
    if (!columns?.length)
        return null;
    const makeListItem = (links) => links.map((link) => (React.createElement(ListItem, { key: link.title, className: cx('listItem') },
        React.createElement(Link, { href: link.url, color: "dark" }, link.title))));
    const makeLists = () => columns.map((group, index) => (
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(Text, { key: index, className: cx('preFooter__group') },
        React.createElement("div", { className: cx('groupTitle') }, group.title),
        React.createElement(UnorderedList, null, makeListItem(group.links)))));
    return (React.createElement("div", { ref: ref, "data-qa": "PreFooter", className: cx(className, 'container'), ...restProps },
        React.createElement(Layout, { className: cx('container', 'preFooter') },
            React.createElement("div", { className: cx('title') }, title),
            React.createElement(Space, { className: cx('links') }, makeLists()))));
});

export { PreFooter };
//# sourceMappingURL=PreFooter.js.map
